import { render, staticRenderFns } from "./TaskPages.vue?vue&type=template&id=3d24f8ef&scoped=true"
import script from "./TaskPages.vue?vue&type=script&lang=js"
export * from "./TaskPages.vue?vue&type=script&lang=js"
import style0 from "./TaskPages.scss?vue&type=style&index=0&id=3d24f8ef&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24f8ef",
  null
  
)

export default component.exports